// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonTextBold_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M5 2H4L3 0H14C17.3137 0 20 2.68629 20 6C20 7.70128 19.2919 9.23719 18.1544 10.3291C20.9646 11.2295 23 13.8757 23 17C23 20.866 19.8834 24 16.039 24C16.0111 24 15.9833 23.9998 15.9556 23.9995L1 24L2 22H5V2ZM9 10H13C15.2091 10 17 8.20914 17 6C17 3.79086 15.2091 2 13 2H9V10ZM19 17C19 19.7614 16.7614 22 14 22H9V12H14C16.7614 12 19 14.2386 19 17Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonTextBold is a generated icon component.
 */
let IconCommonTextBold = IconCommonTextBold_1 = class IconCommonTextBold extends IconBaseElement {
    render() {
        return html `${IconCommonTextBold_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonTextBold.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconCommonTextBold = IconCommonTextBold_1 = __decorate([
    customElement('zui-icon-common-text-bold')
], IconCommonTextBold);
export { IconCommonTextBold };
